import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FlaskConical, FileText, Microscope } from "lucide-react";
import LabAnalysis from "./LabAnalysis";
import ResumenLaboratorio from "./ResumenLaboratorio";
import AnalisisLaboratorio from "./AnalisisLaboratorio";

const TABS = [
  { to: "/labs", label: "Análisis", icon: FlaskConical, testid: "labs-tab-analisis" },
  { to: "/labs/resumen", label: "Resumen por laboratorio", icon: FileText, testid: "labs-tab-resumen" },
  { to: "/labs/laboratorio", label: "Análisis de un laboratorio", icon: Microscope, testid: "labs-tab-laboratorio" },
];

export default function Laboratorios() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  const Page = pathname.startsWith("/labs/resumen") ? ResumenLaboratorio : pathname.startsWith("/labs/laboratorio") ? AnalisisLaboratorio : LabAnalysis;
  return (
    <div data-testid="laboratorios-page">
      <div className="px-4 sm:px-8 pt-6 flex gap-2 border-b border-slate-200 overflow-x-auto" data-testid="labs-tabs">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end data-testid={t.testid}
            className={({ isActive }) => `inline-flex items-center gap-2 px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px whitespace-nowrap transition-colors ${isActive ? "border-slate-900 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
            <t.icon size={15} /> {t.label}
          </NavLink>
        ))}
      </div>
      <Page />
    </div>
  );
}
